if (!customElements.get('video-resources')) {
  customElements.define(
    'video-resources',
    class VideoResources extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          videos: this.querySelectorAll('nav a'),
          iframe: this.querySelector('iframe'),
          title: this.querySelector('figure h3'),
        };

        this.elements.videos.forEach(video => {
          video.addEventListener('click', this.selectVideo.bind(this));
        });
      }

      selectVideo(e) {
        e.preventDefault();

        const id = e.currentTarget.dataset.id;
        if (!id) return;

        // Swap the iframe source
        this.elements.iframe.src = `https://www.youtube.com/embed/${id}?enablejsapi=1&autoplay=1`;

        // Set the title
        this.elements.title.innerHTML = e.currentTarget.querySelector('span').innerHTML;
      }
    }
  );
}